import React, {
  useContext
} from "react";
import { AppBootstrapContext, type AppBootstrapContextValue } from "./appBootstrapContext";
import { useAppBootstrapViewModel } from './useAppBootstrapViewModel';

export const AppBootstrapProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { contextValue } = useAppBootstrapViewModel();

  return (
    <AppBootstrapContext.Provider value={contextValue}>
      {children}
    </AppBootstrapContext.Provider>
  );
};

export const useAppBootstrap = (): AppBootstrapContextValue => {
  const context = useContext(AppBootstrapContext);

  if (!context) {
    throw new Error("useAppBootstrap must be used inside AppBootstrapProvider");
  }

  return context;
};
